import bindAll from 'lodash.bindall';
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
// import queryString from 'query-string';
import VM from 'scratch-vm';

import {
    setSeedsWorkspaceId,
    setSeedsReadOnly
} from '../reducers/seeds-workspace';
import {fetchBrickLabUser} from '../reducers/bricklab-user';
import {initAuthFromURL, loadProjectFromSEEDS} from './seeds-api';
import {activateTab, BLOCKS_TAB_INDEX} from '../reducers/editor-tab';
import {setProjectUnchanged} from '../reducers/project-changed';
import {setProjectTitle} from '../reducers/project-title';

/* Higher Order Component to load projects from SEEDS backend
 * @param {React.Component} WrappedComponent: component to render
 * @returns {React.Component} component with SEEDS project loading behavior
 */
const SeedsProjectLoaderHOC = function (WrappedComponent) {
    class SeedsProjectLoaderComponent extends React.Component {
        constructor (props) {
            super(props);
            bindAll(this, ['loadSeedsProject']);
            this.state = {
                loading: false,
                error: null
            };
        }
        componentDidMount () {
            const {workspaceId, classId, isSharedWorkspace, token} =
                initAuthFromURL();
            this.props.onSetSeedsReadOnly(isSharedWorkspace === 'true');
            if (token) {
                this.props.onFetchBrickLabUser();
            }
            if (workspaceId) {
                this.props.onSetSeedsWorkspaceId(workspaceId);
                this.loadSeedsProject(workspaceId, classId);
            }
        }
        loadSeedsProject (workspaceId, classId) {
            this.setState({loading: true, error: null});
            let workspaceName = 'Untitled';
            loadProjectFromSEEDS(workspaceId, classId)
                .then(workspace => {
                    if (workspace && workspace.sb3Url) {
                        workspaceName = workspace.workspaceName || 'Untitled';
                        return fetch(workspace.sb3Url);
                    }
                    throw new Error('Could not find project');
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Failed to download project');
                    }
                    return response.arrayBuffer();
                })
                .then(arrayBuffer => this.props.vm.loadProject(arrayBuffer))
                .then(() => {
                    this.setState({loading: false});
                    this.props.onSetProjectTitle(workspaceName);
                    this.props.onProjectUnchanged();
                    this.props.onActivateTab(BLOCKS_TAB_INDEX);
                })
                .catch(err => {
                    this.setState({loading: false, error: err.message});
                    // eslint-disable-next-line no-console
                    console.error('Failed to load SEEDS project:', err);
                });
        }
        render () {
            const {
                /* eslint-disable no-unused-vars */
                onSetSeedsWorkspaceId,
                isReadOnly,
                onSetSeedsReadOnly,
                onProjectUnchanged,
                onActivateTab,
                onSetProjectTitle,
                onFetchBrickLabUser,
                vm,
                /* eslint-enable no-unused-vars */
                ...componentProps
            } = this.props;
            return (
                <WrappedComponent
                    isReadOnly={isReadOnly}
                    {...componentProps}
                />
            );
        }
    }
    SeedsProjectLoaderComponent.propTypes = {
        onActivateTab: PropTypes.func,
        onSetProjectTitle: PropTypes.func,
        onProjectUnchanged: PropTypes.func,
        onSetSeedsWorkspaceId: PropTypes.func,
        onSetSeedsReadOnly: PropTypes.func,
        onFetchBrickLabUser: PropTypes.func,
        isReadOnly: PropTypes.bool,
        vm: PropTypes.instanceOf(VM)
    };
    const mapStateToProps = state => ({
        vm: state.scratchGui.vm,
        isReadOnly: state.scratchGui.seedsWorkspace.isReadOnly
    });
    const mapDispatchToProps = dispatch => ({
        onSetSeedsWorkspaceId: workspaceId =>
            dispatch(setSeedsWorkspaceId(workspaceId)),
        onSetSeedsReadOnly: isReadOnly =>
            dispatch(setSeedsReadOnly(isReadOnly)),
        onSetProjectTitle: title => dispatch(setProjectTitle(title)),
        onProjectUnchanged: () => dispatch(setProjectUnchanged()),
        onActivateTab: tab => dispatch(activateTab(tab)),
        onFetchBrickLabUser: () => dispatch(fetchBrickLabUser())
    });
    return connect(
        mapStateToProps,
        mapDispatchToProps
    )(SeedsProjectLoaderComponent);
};

export {SeedsProjectLoaderHOC as default};
